import { PerkTemplate } from './models/PerkTemplate';

export function filterTemplates(templates: PerkTemplate[], searchValue: string): PerkTemplate[] {
    if (!searchValue) {
        return templates;
    }
    const lower = searchValue.toLowerCase();
    return templates.filter(
        t =>
            t.name?.toLowerCase().includes(lower) ||
            t.description?.toLowerCase().includes(lower) ||
            t.perk?.template?.toLowerCase().includes(lower) ||
            t.perk?.token?.toLowerCase().includes(lower)
    );
}
